/* @flow */

import { Settings } from 'luxon';
import * as React from 'react';

import useMembershipTimezone from 'src/shared/domain/membership/hook/useMembershipTimezone';

export default function useSetAppTimezone() {
  const timezone = useMembershipTimezone();
  React.useEffect(() => {
    Settings.defaultZone = timezone;
  }, [timezone]);

  return timezone;
}
